__turbopack_context__.v({
  "mainContainer": "Home-module__-HUO1a__mainContainer",
});
